module.exports = __webpack_public_path__ + "img/plus-circle-solid-white.00e6ee41.svg";